const PageButton = (props) => {
  return (
    <>
      <button className={props.styleValue} onClick={props.eventHandlerFunction}>{props.buttonText}</button>
    </>
  )
}

export default PageButton
